import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonUpgrade from '../ButtonUpgrade';
import ModalToAddItem from '../ModalToAddItem';

const ButtonNewItemFromDownload = props => {
  const { isPremium, isFreeUserAtLimit } = props;
  const [openModal, setOpenModal] = useState(false);

  if (!isPremium && isFreeUserAtLimit) {
    return <ButtonUpgrade />;
  }

  return (
    <>
      <Button
        variant="outlined"
        color="success"
        onClick={() => setOpenModal(true)}
        title="Upload"
        style={{ minWidth: '38px', height: '38px', padding: 0, borderRadius: '4px' }}
      >
        <FontAwesomeIcon icon="upload" />
      </Button>
      <ModalToAddItem open={openModal} handleClose={() => setOpenModal(false)} {...props} />
    </>
  );
};

ButtonNewItemFromDownload.propTypes = {
  isFreeUserAtLimit: PropTypes.bool.isRequired,
  isPremium: PropTypes.bool.isRequired
};

export default ButtonNewItemFromDownload;
